import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { SubscriptionCardProps } from '../../components/Molecules';
import { CloudStorageTemplate } from '../../components/Templates';
import useRedirectEntry from '../../hooks/useRedirectEntry';
import { useRewardStore } from '../../stores/RewardStore';
import { useSessionStore } from '../../stores/SessionStore';
import { useUserStore } from '../../stores/UserStore';

const { manageWebPlanSubscription } = useRewardStore.getState();

const CloudStorageScreen = () => {
  const navigate = useNavigate();

  useRedirectEntry({ allowTrial: false });

  const activeUserId = useSessionStore((store) => store.activeUserId);
  const account = useUserStore((state) => state.getAccount(activeUserId ?? ''));
  const profile = useUserStore((state) => state.getProfile(activeUserId ?? ''));

  const onClickUpgrade = useCallback(() => {
    navigate('/subscription');
  }, [navigate]);

  const onClickDetail = useCallback(() => {
    if (account?.stripeCustomerId) {
      manageWebPlanSubscription('system')
        .then((url) => {
          if (url) {
            window.location.href = url;
          }
        })
        .catch(console.error);
    }
  }, [account?.stripeCustomerId]);

  const currentPlanProps: SubscriptionCardProps = useMemo(() => {
    if (!account?.activeWebPlanTier) {
      return {
        tier: undefined,
        period: undefined,
        createdItemCount: profile?.createdItemCount,
        onClickUpgrade: onClickUpgrade,
        onClickDetail: account?.stripeCustomerId ? onClickDetail : undefined,
      };
    }
    return {
      tier: account?.webPlanSubscription?.tier,
      period: account?.webPlanSubscription?.period,
      expiredAt: account?.webPlanSubscription?.expiredAt,
      willAutoRenew: account?.webPlanSubscription?.willAutoRenew,
      createdItemCount: profile?.createdItemCount,
      // onClickUpgrade: onClickUpgrade, // TODO
      onClickDetail: account?.stripeCustomerId ? onClickDetail : undefined,
    };
  }, [
    account?.stripeCustomerId,
    account?.activeWebPlanTier,
    account?.webPlanSubscription,
    profile?.createdItemCount,
    onClickUpgrade,
    onClickDetail,
  ]);

  return <CloudStorageTemplate currentPlanProps={currentPlanProps} />;
};

export default CloudStorageScreen;
